import * as React from 'react';
import { Box } from '@amzn/awsui-components-console';
import { Store } from 'src/stores/store.interface';
import { useStore } from 'src/stores/store';
import { SUB_WORKFLOW_TASK_TYPE } from 'src/constants/CommonConstants';
import TaskInputs from 'src/components/commonComponents/taskInputs/taskInputs';
import SubWorkflowTaskInputs from '../subWorkflowTaskInputs/subWorkflowTaskInputs';

export default function TaskSpecificTaskInputs() {
	const taskInputs = useStore(
		(state: Store) => state.activeTaskDefinition.taskInputs
	);
	const taskType = useStore(
		(state: Store) => state.activeTaskDefinition.taskType
	);
	const setTaskInputs = useStore((state: Store) => state.setTaskInputs);
	const isFirstSubmissionDone = useStore(
		(state: Store) => state.isFirstSubmissionDone
	);

	if (taskType === SUB_WORKFLOW_TASK_TYPE) {
		return <SubWorkflowTaskInputs />;
	}

	return (
		<div data-testid="taskSpecificTaskInputs">
			{taskInputs?.length > 0 ? (
				<TaskInputs
					taskInputs={taskInputs}
					setTaskInputs={setTaskInputs}
					isFirstSubmissionDone={isFirstSubmissionDone}
				/>
			) : (
				<Box textAlign="center" color="text-body-secondary" padding="m">
					No task-specific inputs defined for this task type
				</Box>
			)}
		</div>
	);
}
